<template>
  <el-upload :limit="1" action="" :http-request="uploadFile" :show-file-list="false" :auto-upload="true"
    :file-list="fileList" accept=".xls, .xlsx" ref="uploadFileXls">
    <el-button :loading="loading">导入评论</el-button>
  </el-upload>
</template>
<script>
export default {
  props: {
    limit: Number,
    fileList: {
      type: Array,
      default: () => { },
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    uploadFile (e) {
      const file = e.file
      const size = file.size / 1024 / 1024 / 5
      // if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
      if (size > 5) {
        this.$notify.warning({
          title: '警告',
          message: '文件大小必须小于5M'
        })
      } else {
        const params = new FormData()
        params.append('file', file)
        this.loading = true
        this.$api.uploadCommentExport(params).then(res => {
          if (res.code === 0 && res.data !=='error') {
            this.$message.success('已成功导入评论！')
            this.$emit('update')
          } else if(res.code !==103 && !res.code.message) {
            this.$message.error('导入失败，请检查文件是否正确！')
          }
          this.loading = false
          this.fileList = []
        }).catch((err) => {
          console.log(err)
          this.loading = false
          this.fileList = []
        })
      }
    },
  }
}
</script>

